import {appHelper} from "../../../utils/helpers/appHelper.js";
import auth from "../../../middleware/auth.js";
import shortcuts from "../../../middleware/shortcuts.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";

/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 01/11/2024
 */
export const AmsAppDefaults = [
    {
        path: appHelper.path.amsApp,
        name:'amsApp',
        component: routeHelper.asyncComponentWithLoader(() => import('../views/dashboard/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'amsAppUpload',
        path: appHelper.path.amsApp + '/media-manager',
        component: routeHelper.asyncComponentWithLoader(() => import('../../media/views/media-manager/mediaManager.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'amsAppCustomField',
        path: appHelper.path.amsApp + '/custom-field',
        component: routeHelper.asyncComponentWithLoader(() => import('../../admin/views/custom-field/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'amsAppCustomForm',
        path: appHelper.path.amsApp + '/custom-form',
        component: routeHelper.asyncComponentWithLoader(() => import('../../admin/views/custom-form/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'amsAppSetting',
        path: appHelper.path.amsApp + '/setting',
        component: routeHelper.asyncComponentWithLoader(() => import('../../admin/views/settings/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    }
];
